import script from "./DropZone2.vue?vue&type=script&setup=true&lang=js"
export * from "./DropZone2.vue?vue&type=script&setup=true&lang=js"

import "./DropZone2.vue?vue&type=style&index=0&id=8b444678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b444678"]])

export default __exports__